import React, { useEffect, useState } from "react";
import { Box, styled } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const FloatingWrapper = styled(Box)(({ visible }) => ({
  position: "fixed",
  bottom: "1%",
  right: "0",
  transform: "translateY(-50%)",
  zIndex: 99999,
  display: "flex",
  flexDirection: "column",
  gap: "1px",
  alignItems: "flex-end",
  opacity: visible ? 1 : 0,
  pointerEvents: visible ? "auto" : "none",
  transition: "opacity 0.4s ease",
}));

const ActionButton = styled(Box)(({ bgcolor }) => ({
  height: "55px",
  width: "55px",
  background: bgcolor,
  borderRadius: "50px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: "white",
  overflow: "hidden",
  boxShadow: "0 6px 15px rgba(0,0,0,0.25)",
  transition: "width 0.3s ease, padding 0.3s ease",
  position: "relative",

  "&:hover": {
    width: "180px",
    justifyContent: "flex-start",
    paddingLeft: "18px",
  },
}));

const IconBox = styled(Box)({
  width: "26px",
  minWidth: "26px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const Label = styled("span")({
  marginLeft: "12px",
  whiteSpace: "nowrap",
  maxWidth: "0px",
  display: 'none',
  transition: "all 0.3s ease",
});

const FloatingActions = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // adjust this value based on position of your main banner
      const triggerHeight = 500; 
      if (window.scrollY > triggerHeight) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <FloatingWrapper visible={visible}>
      <ActionButton bgcolor="#FF3B5C" className="fab" component="a" href="tel:+919528294837">
        <IconBox><PhoneIcon sx={{ fontSize: 26 }} /></IconBox>
        <Label className="fab-label">Call Now</Label>
      </ActionButton>

      <ActionButton
        bgcolor="#25D366"
        className="fab"
        component="a"
        href="https://wa.me/919528294837"
        target="_blank"
      >
        <IconBox><WhatsAppIcon sx={{ fontSize: 26 }} /></IconBox>
        <Label className="fab-label">WhatsApp</Label>
      </ActionButton>
    </FloatingWrapper>
  );
};

export default FloatingActions;
